import React from 'react';
import cn from 'classnames';

const Section = ({
  id,
  container,
  bg,
  center,
  relative,
  paddingTop,
  paddingBottom,
  children,
  overflowHidden
}) => (
  <section
    id={id}
    className={cn('py-[72px] lg:py-32', `${bg}`, {
      'text-center': center,
      'pt-0 lg:pt-0': !paddingTop,
      'pb-0 lg:pb-0': !paddingBottom,
      'overflow-hidden': overflowHidden,
      relative
    })}
  >
    <div className={cn({ container })}>{children}</div>
  </section>
);

Section.defaultProps = {
  id: '',
  container: true,
  bg: 'bg-transparent',
  center: false,
  relative: false,
  paddingTop: true,
  paddingBottom: true,
  overflowHidden: false
};

export default Section;
